var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40202 9.40202 0 21 0C32.598 0 42 9.40202 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#5AB2AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1198 15.24C18.1198 14.4464 18.7662 13.8 19.5598 13.8H22.4398C23.2334 13.8 23.8798 14.4464 23.8798 15.24V16.68H26.7598C27.5534 16.68 28.1998 17.3264 28.1998 18.12V26.04C28.1998 26.8337 27.5534 27.48 26.7598 27.48H15.2398C14.4462 27.48 13.7998 26.8337 13.7998 26.04V18.12C13.7998 17.3264 14.4462 16.68 15.2398 16.68H18.1198V15.24ZM19.5598 16.68H22.4398V15.24H19.5598V16.68ZM15.2398 18.12V26.04H26.7598V18.12H15.2398ZM20.9998 19.56C21.3974 19.56 21.7198 19.8824 21.7198 20.28V21.72H23.1598C23.5574 21.72 23.8798 22.0424 23.8798 22.44C23.8798 22.8377 23.5574 23.16 23.1598 23.16H21.7198V24.6C21.7198 24.9977 21.3974 25.32 20.9998 25.32C20.6022 25.32 20.2798 24.9977 20.2798 24.6V23.16H18.8398C18.4422 23.16 18.1198 22.8377 18.1198 22.44C18.1198 22.0424 18.4422 21.72 18.8398 21.72H20.2798V20.28C20.2798 19.8824 20.6022 19.56 20.9998 19.56Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.f384e55ece2fe4603521c9070bca4001.svg";
export { ForwardRef as ReactComponent };